import React from 'react'

const TablaDiagnosticoDescripcionQxPostOperatorio = ({item}) => {
  return (
    <tr key={item.DMCodi} className="border-b bg-white" >
      
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.CodDxPrPo}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-center">
        {item.DMNomb}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.CodObsDx}
      </td>
      
    </tr>
  )
}

export default TablaDiagnosticoDescripcionQxPostOperatorio